import { motion } from 'framer-motion';
import { ShieldBlockEffect, CrownLossEffect, CrownGainEffect, JollyEffect, PlayerShake } from './GameAnimations';
import { PlayerBox } from './PlayerBox';

const PlayerAvatar = ({
  player,
  isActive,
  isCurrentUser = false,
  compact = false,
  side = false,
  animEffect = null,
  playerIndex = 0,
  boxWidth = 280,
  sideLabel = null,
  size = null,
}) => {
  if (!player) return null;

  const hasShieldBlock = animEffect === 'shield_block';
  const hasCrownLoss   = animEffect === 'crown_loss';
  const hasCrownGain   = animEffect === 'crown_gain';
  const hasJolly       = animEffect === 'jolly';
  const isPrisoned     = player.is_frozen;

  const effects = (
    <>
      <ShieldBlockEffect active={hasShieldBlock} />
      <CrownLossEffect   active={hasCrownLoss} />
      <CrownGainEffect   active={hasCrownGain} />
      <JollyEffect       active={hasJolly} />
    </>
  );

  // ── MOBILE SIDE (compact + side) ──
  if (compact && side) {
    return (
      <PlayerShake active={hasCrownLoss}>
        <div style={{ position: 'relative' }}>
          {effects}
          <PlayerBox player={player} isActive={isActive} isPrisoned={isPrisoned} size="side" sideLabel={sideLabel} />
        </div>
      </PlayerShake>
    );
  }

  // ── MOBILE TOP (compact, not current user) ──
  if (compact && !isCurrentUser) {
    return (
      <PlayerShake active={hasCrownLoss}>
        <div style={{ position: 'relative' }}>
          {effects}
          <PlayerBox player={player} isActive={isActive} isPrisoned={isPrisoned} size="top" />
        </div>
      </PlayerShake>
    );
  }

  // ── MOBILE CURRENT PLAYER ──
  if (compact && isCurrentUser) {
    return (
      <PlayerShake active={hasCrownLoss}>
        <motion.div
          animate={isActive && !isPrisoned ? {
            filter: ['drop-shadow(0 0 0px rgba(255,215,0,0))', 'drop-shadow(0 0 10px rgba(255,215,0,0.4))', 'drop-shadow(0 0 0px rgba(255,215,0,0))']
          } : {}}
          transition={{ duration: 1.8, repeat: Infinity }}
          style={{ position: 'relative' }}
        >
          {effects}
          <PlayerBox player={player} isActive={isActive} isPrisoned={isPrisoned} size="self" />
        </motion.div>
      </PlayerShake>
    );
  }

  // ── DESKTOP / LANDSCAPE — all players ──
  const desktopSize = size || (isCurrentUser ? 'self' : boxWidth < 200 ? 'top' : 'desktop');

  return (
    <PlayerShake active={hasCrownLoss}>
      <motion.div
        animate={isActive && !isPrisoned && isCurrentUser ? {
          filter: ['drop-shadow(0 0 0px rgba(255,215,0,0))', 'drop-shadow(0 0 16px rgba(255,215,0,0.35))', 'drop-shadow(0 0 0px rgba(255,215,0,0))']
        } : {}}
        transition={{ duration: 1.8, repeat: Infinity }}
        style={{ position: 'relative' }}
      >
        {effects}
        <PlayerBox player={player} isActive={isActive} isPrisoned={isPrisoned} size={desktopSize} />
      </motion.div>
    </PlayerShake>
  );
};

export default PlayerAvatar;
